import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationDivider from "../components/PersonalizationDivider";
import PersonalizationBoolean from "../components/PersonalizationBoolean";

export default function WellnessMetricPdfTitle({getWellnessError, wellnessFormData,setWellnessFormData}) {
    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_health.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title on PDF:'}
            value={wellnessFormData?.healthPdfTitle}
            setValue={(value) => setWellnessFormData({healthPdfTitle: value})}
            error={getWellnessError('wellnessSettings','healthPdfTitle')}
        />

        <PersonalizationDivider/>

        <p
            style={{
                color:'#494949',
            }}
        >
            Do you want your patients to see their last score when continuing surveys (from Survey 2 onwards)? If enabled, the previous score will be shown for all 6 health metric section below the question/statement.
        </p>

        <PersonalizationBoolean
            title={'Show Last Score'}
            isChecked={wellnessFormData?.healthLastScore}
            setIsChecked={(value) => setWellnessFormData({healthLastScore: value})}
            errorMessage={getWellnessError('wellnessSettings','healthLastScore')}
        />
    </div>
}
